import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { setupGlobalErrorHandler } from "./lib/errorReporter";
import ErrorBoundary from "@/components/ErrorBoundary";

// Setup global error monitoring
setupGlobalErrorHandler();

createRoot(document.getElementById("root")!).render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>
);
